import { render, staticRenderFns } from "./IQ.vue?vue&type=template&id=7c91fa6a&scoped=true&"
import script from "./IQ.vue?vue&type=script&lang=js&"
export * from "./IQ.vue?vue&type=script&lang=js&"
import style0 from "./IQ.vue?vue&type=style&index=0&id=7c91fa6a&lang=scss&scoped=true&"
import style1 from "./IQ.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c91fa6a",
  null
  
)

export default component.exports